import { createNotificationComponent } from '@vfde-brix/notification';
import { HtmlId } from '../container/App/enum';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountNotification = (wrapperId: HtmlId) => {
    const containerEl = document.getElementById(wrapperId);

    return containerEl && createNotificationComponent(containerEl, NO_PATTERN_BUSINESS_LOGIC);
};
